import { API } from 'app/services';
import { useAsyncTask, useRouter } from 'app/utils';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ScreeningDetail_Others from './ScreeningDetail_Others';
import ScreeningDetailRegtank from './ScreeningDetailRegtank';

function ScreeningDetail(props) {
  const { routeType = 'account', screenId } = props;
  const access = useSelector((state) => state.profile.access);
  const [runLoadScreening] = useAsyncTask('getScreening');
  const router = useRouter();
  const { match } = router;
  const { params } = match;
  const { enqueueSnackbar } = useSnackbar();

  const screening_id = params.screening_id || screenId;
  const [screeningData, setScreeningData] = useState(null);

  useEffect(() => {
    if (access && access.token) getScreening();
    // eslint-disable-next-line
  }, [access]);
  /**
   * Get the screening details
   * @returns the screening details
   */
  useEffect(() => {
    if (screeningData?.status !== 'verifying' && screeningData?.status !== 'screening') {
      return;
    }

    const interval = setInterval(() => {
      updateStatus();
    }, 2000);

    return () => clearInterval(interval);
  }, [screeningData?.status]);

  const updateStatus = async () => {
    if (!screening_id) {
      return enqueueSnackbar('invalid id');
    }

    const loader = routeType === 'account' ? API.Screening.update_status : API.Admin.update_status;

    await loader(screening_id);

    await getScreening();
  };

  const getScreening = () => {
    if (!screening_id) {
      return enqueueSnackbar('invalid id');
    }

    runLoadScreening(async () => {
      const loader = routeType === 'account' ? API.Screening.get_screen : API.Admin.get_screen;

      const response = await loader(screening_id);

      setScreeningData(response.model);
    });
  };

  if (!screeningData) return null;

  const isRegtank = screeningData.screen_provider_id == 4;

  return isRegtank ? <ScreeningDetailRegtank {...props} screeningData={screeningData} /> : <ScreeningDetail_Others {...props} screeningData={screeningData} />;
}

export default ScreeningDetail;
